module.exports = __webpack_public_path__ + "img/v3-cogs.ac8baf4c.svg";